(function() { window.GUID_13f6869c_bc28_4342_a22b_1a392fc4f41f = { getGuid: function() { return "13f6869c-bc28-4342-a22b-1a392fc4f41f"; } }; })();
Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    return (this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};
// var num = 5
// num.map(0,10,0,100)  //retourne 50

//# sourceMappingURL=cs.math.js.map
